import ClockIcon from 'assets/icons/clock.svg';
import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { getTimeString } from 'utils/datetime';

import s from './ReadTime.module.scss';

const cx = cn.bind(s);

const ReadTime = ({
  className, format = 'short', color, time = 0, ...attrs
}) => {
  const timeString = getTimeString(time, {
    hourFormat: format,
    minuteFormat: 'short',
  });
  return (
    <div className={cx(className, 'wrapper', color)} {...attrs}>
      <ClockIcon className={cx('icon')} />
      <span className={cx('text')}>{timeString}</span>
    </div>
  );
};

ReadTime.propTypes = {
  color: PropTypes.string,
  format: PropTypes.oneOf(['short', 'long']),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default ReadTime;
